/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { PersonAdd, Edit } from '@material-ui/icons';
import { Link, useTranslation } from '~/dependencies';
import { isLocalExtension, eventTracker } from '~/helpers';
import { NewSession } from '~/components/ActiveCall/types';
import { Button } from './styles';

type ContactButtonProps = {
  session: NewSession;
};

const Contact = ({ session }: ContactButtonProps) => {
  const { answered, numberFrom, contactId } = session;

  const { t } = useTranslation();

  const isContactSaved = !!contactId;

  const title = isContactSaved
    ? t('components.activeCalls.btn.editContact')
    : t('components.activeCalls.btn.addContact');

  function clickLinkHandler() {
    if (!isContactSaved) {
      eventTracker(
        // @ts-ignore
        events => events.InCallAddAContactClicked
      );
    }
  }

  return (
    <>
      {!isLocalExtension(numberFrom) && (
        <Link
          aria-label={title}
          to={{
            pathname: `/app/addNewContact`,
            state: {
              ...(!isContactSaved && {
                landLine: numberFrom,
              }),
              ...(isContactSaved && {
                id: contactId,
                edit: true,
              }),
            },
            ...(isContactSaved && {
              hash: '#edit',
            }),
          }}>
          <Button
            type="button"
            title={title}
            disabled={!answered}
            aria-label={title}
            onClick={clickLinkHandler}>
            {isContactSaved ? (
              <Edit className="icon" />
            ) : (
              <PersonAdd className="icon" />
            )}
          </Button>
        </Link>
      )}
    </>
  );
};

export default Contact;
